<template>
    <div>
        <!-- <el-card>
            <el-alert title="订单送券" type="success" description="(1)订单满减送券
            (2)订单指定产品送券
            (3)订单指定品类送券
            (4)都可指定门店参与和指定门店不参与活动
            注:下完订单后会自动弹出送出的优惠券，可点击立即使用到券可以使用产品页面，进行购买下单完成，需要页面展示买那些产品可以送券">
            </el-alert>
        </el-card> -->
        <el-form ref="form" :model="form" label-width="100px">
            <el-form-item label="活动标题">
                <el-input v-model="form.title" :maxlength="50" show-word-limit style="width: 60%;"></el-input>
            </el-form-item>
            <el-form-item label="活动内容">
                <el-input type="textarea" v-model="form.description" :maxlength="300" show-word-limit
                    style="width: 60%;"></el-input>
            </el-form-item>
            <el-form-item label="活动时间">
                <el-date-picker v-model="form.times" type="daterange" range-separator="至" start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="状态">
                <el-radio-group v-model="form.status" style="">
                    <el-radio :label="1">开启</el-radio>
                    <el-radio :label="0">关闭</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="满足条件">
                <el-col :span="4">
                  1. 满足金额 <el-input type="text" style="width: 100px;" :maxlength="5" v-model="form.amount"></el-input> 元
                </el-col>
                <el-col :span="4">
                  2. 满足 <el-input style="width: 100px;" :maxlength="5" v-model.number="form.number"></el-input> 件
                </el-col>
                <el-col :span="4">
                    <el-radio-group v-model="form.is_full" style="">
                        <el-radio :label="0">二选一</el-radio>
                        <el-radio :label="1">全部满足</el-radio>
                    </el-radio-group>
                </el-col>
            </el-form-item>
            <el-form-item label="送券类型">
                <el-radio-group v-model="form.use_type" @change="changeType">
                    <el-radio label="card">满减送券</el-radio>
                    <!-- <el-radio label="items">赠送商品</el-radio> -->
                    <el-radio label="offlinecard">送线下券</el-radio>
                    <el-radio label="package">组合券包</el-radio>
                </el-radio-group>
            </el-form-item>

             <el-card v-if="form.use_type == 'card'" style="width: 70%;">
                <div slot="header" class="clearfix">
                    <el-button @click="showCoupons" size="mini" type="primary">选择优惠券+</el-button>
                </div>
                <div v-if="form.cardinfo.length > 0" class="text item">
                  <div v-for="(item, index) in form.cardinfo" :key="item.id">
                    <el-tag  closable type="success"
                        @close="handleClose(item)">
                        ID:{{ item.id }} : {{ item.title }}
                    </el-tag>
                    发券数量: <el-input type="text" style="width: 65px;" v-model="form.cardinfo[index].num" size="mini"></el-input>
                  </div>
                </div>
                <!-- <el-form-item label="优惠券券数量">
                  <el-input v-model="form.cardinfo" style="width: 500px;"></el-input>
                  <el-tag>券数量逗号隔开，例如1,2,3,4,5，必须一一对应</el-tag>
                </el-form-item> -->
            </el-card>
             <el-card v-else-if="form.use_type == 'offlinecard'" style="width: 70%;">
                <div slot="header" class="clearfix">
                    <el-button @click="addRule" size="mini" type="primary">添加线下券</el-button>
                </div>
                <div v-if="form.cardinfo.length > 0" class="text item">
                  <div v-for="(item, index) in form.cardinfo" :key="item.keys" style="margin: 15px 0;">
                    线下券编码: <el-input type="text" style="width: 165px;" v-model="form.cardinfo[index].id"></el-input>
                    优惠券名称: <el-input type="text" style="width: 285px;" v-model="form.cardinfo[index].title"></el-input>
                    发券数量: <el-input type="text" style="width: 65px;" v-model="form.cardinfo[index].num"></el-input>
                    <el-button type="danger" @click="handleClose(item)">删除</el-button>
                  </div>
                </div>
            </el-card>
            <el-form-item label="组合券包" v-else>
                <el-select v-model="form.send_card_ids" placeholder="请选择" style="width: 300px;">
                    <el-option
                    v-for="item in selectList"
                    :key="item.package_num_id"
                    :label="item.package_name"
                    :value="item.package_num_id">
                    </el-option>
                </el-select>
            </el-form-item>
            <!-- <el-card v-if="form.use_type == 'items'" style="width: 70%;">
                <div slot="header" class="clearfix">
                    赠送商品
                </div>
            </el-card> -->
            <el-form-item label="指定商品" style="width: 70%;">
                <el-radio-group v-model="form.items_canuse" @change="changeItems">
                    <el-radio :label="0">全部商品</el-radio>
                    <el-radio :label="1">指定商品参与</el-radio>
                    <el-radio :label="2">指定商品不参与</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-card v-if="form.items_canuse > 0" style="width: 70%;">
                <div slot="header" class="clearfix">
                    选择商品
                </div>
                <div class="text item">
                    <SkuSelector v-if="!zdItemHidden" @change="getItems" :data="relItems"></SkuSelector>
                </div>
            </el-card>
            <el-form-item label="指定门店">
                <el-radio-group v-model="form.distributor_canuse" @change="changeDistributor">
                    <el-radio :label="0">全部门店</el-radio>
                    <el-radio :label="1">指定门店参与</el-radio>
                    <el-radio :label="2">指定门店不参与</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-card v-if="form.distributor_canuse > 0" style="width: 70%;">
                <div slot="header" class="clearfix">
                    <el-button type="primary" size="mini" @click="addDistributorAction">选择店铺+</el-button>
                </div>
                <div class="text item">
                    <div v-if="!zdShopHidden">
                        <el-table v-if="distributor_list.length > 0" :data="distributor_list" style="line-height: normal">
                            <el-table-column label="ID" prop="distributor_id" width="60"></el-table-column>
                            <el-table-column label="名称" prop="name"></el-table-column>
                            <el-table-column prop="address" label="地址" show-overflow-tooltip></el-table-column>
                            <el-table-column label="操作" width="50">
                                <template slot-scope="scope">
                                    <i class="iconfont icon-trash-alt"
                                        @click="deleteDistritutorRow(scope.$index, form.items)"></i>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-card>
            <el-form-item>
                <el-button type="primary" @click="onSubmit">保存</el-button>
                <el-button @click.native="handleCancel">取消</el-button>
            </el-form-item>
        </el-form>
        <couponPicker :visible="couponsVisible" @pickCoupon="pickCoupon" @closeDialog="closeDialogs"></couponPicker>
        <DistributorSelect :store-visible="distributorVisible" :is-valid="true" :rel-shop-ids="relDistributorIds"
            :get-status="setDistributorStatus" @chooseStore="chooseDistributorAction"
            @closeStoreDialog="closeDistributorDialogAction"></DistributorSelect>

    </div>
</template>
<script>
import {
    mapGetters
} from "vuex";
import DistributorSelect from '@/components/storeListSelect'
import SkuSelector from '@/components/function/skuSelector'
import couponPicker from '@/components/coupon_picker'
import { getItemsList } from '@/api/goods'
import draggable from "vuedraggable";
import {
    getOrderCardList, getOrderCardRow, saveOrderCard, editOrderCard, delOrderCard,getKaquanPackageList
} from "@/api/cardticket";
export default {
    inject: ['refresh'],
    components: {
        draggable,
        SkuSelector,
        DistributorSelect,
        couponPicker
    },
    data() {
        return {
            couponsVisible: false,
            zdShopHidden: true,
            zdItemHidden: true,
            zdItemHidden2: true,
            distributorVisible: false,
            relDistributorIds: '',
            setDistributorStatus: false,
            form: {
                type:0,
                title: '',
                description: '',
                status: 1,
                times: '',
                use_type: 'card',
                distributor_id: [],
                amount: 10.0,
                number: 1,
                send_card_ids: '',
                is_full: 0,
                items_canuse: 0,
                distributor_canuse: 0,
                send_item_ids: [],
                send_item_bns: [],
                rel_item_ids: [],
                rel_item_bns: [],
                cardinfo: [], // 优惠券信息
            },
            sendCardList: [],
            senditemList: [],
            itemList: [],
            distributorList: [],
            relItems: [],
            relItems2: [],
            distributor_list: [],
            selectList:[],
        };
    },
    computed: {
        ...mapGetters(["wheight"]),
    },
    methods: {
        addRule: function () {
            this.form.cardinfo.push({
                id: '', // 线下优惠券编码
                title: '', // 优惠券名称
                num: 1, // 发送数量，默认为 1
            })
            // let data = this.form.cardinfo;
            // let ids = [];
            // data.forEach(element => {
            //     ids.push(element.id)
            // });
            // this.form.send_card_ids = ids;
            // console.log(this.form)
        },
        handleCancel: function () {
            this.$router.back(-1)
        },
        deleteDistritutorRow(index) {
            this.distributor_list.splice(index, 1)
            let shopDatas = this.distributor_list
            this.form.distributor_id = []; // 重新初始化 distributor_id 为空数组（修复删除后店铺ID依然存在的BUG）
            for (var i = 0; i < shopDatas.length; i++) {
                if (this.form.distributor_id.indexOf(Number(shopDatas[i].distributor_id)) < 0) {
                    this.form.distributor_id.push(Number(shopDatas[i].distributor_id))
                }
            }
        },
        addDistributorAction() {
            this.distributorVisible = true
            this.setDistributorStatus = true
            this.relDistributorIds = this.form.distributor_id
        },
        getItems(data) {
            let ids = []
            let bns = []
            data.forEach(item => {
                ids.push(item.itemId)
                bns.push(item.itemBn)
            })
            this.form.rel_item_ids = ids
            this.form.rel_item_bns = bns
        },
        getItems2(data) {
            let ids = []
            let bns = []
            data.forEach(item => {
                ids.push(item.itemId)
                bns.push(item.itemBn)
            })
            this.form.send_item_ids = ids
            this.form.send_item_bns = bns
        },
        chooseDistributorAction(data) {
            this.distributorVisible = false
            if (data === null || data.length <= 0) return
            this.distributor_list = data
            for (var i = 0; i < data.length; i++) {
                if (this.form.distributor_id.indexOf(Number(data[i].distributor_id)) < 0) {
                    this.form.distributor_id.push(Number(data[i].distributor_id))
                }
            }
        },
        closeDistributorDialogAction() {
            this.distributorVisible = false
        },
        goBack() {
            this.$confirm("此操作返回上一个页面, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    history.back(0);
                })
                .catch(() => { });
        },
        // 关闭选取优惠券弹窗
        closeDialogs() {
            console.log('close_coupons')
            this.couponsVisible = false;
        },
        // 选取优惠券
        pickCoupon(data) {
            this.couponsVisible = false
            data.forEach(element => {
                element.num = 1 // 初始化优惠券发送数量，默认为 1
            });
            this.form.cardinfo= data;
            let ids = [];
            data.forEach(element => {
                ids.push(element.id)
            });
            this.form.send_card_ids = ids;
        },
        // 展示选取优惠券弹窗
        showCoupons() {
            console.log('show_coupons')
            this.couponsVisible = true
        },
        handleClose(tag) {
            this.form.cardinfo.splice(this.form.cardinfo.indexOf(tag), 1);
            let ids = [];
            this.form.cardinfo.forEach(element => {
                ids.push(element.id)
            });
            this.form.send_card_ids = ids;
            console.log(this.form.cardinfo)
            console.log(this.form.send_card_ids);
        },
        changeType(e) {
            if (e == 'card') {
                this.form.cardinfo = []
                this.form.send_item_bns = [];
                this.form.send_item_ids = [];
            }
            if (e == 'items') {
                this.zdItemHidden2 = false;
                this.form.send_card_ids = [];
            }
            if (e == 'package') {
                this.getPackageList();
                this.form.send_card_ids = [];
            }
            if (e == 'offlinecard') {
                this.form.cardinfo = []
                this.form.send_card_ids = [];
            }
        },
        getPackageList(){
          getKaquanPackageList({page:1,pagesize:100,is_select:1}).then((response)=>{
            this.selectList = response.data.data;
          });
        },
        changeItems(e) {
            this.zdItemHidden = true
            if (e > 0) {
                this.zdItemHidden = false;
            } else {
                this.form.rel_item_ids = [];
                this.form.rel_item_bns = [];
            }
        },
        changeDistributor(e) {
            this.zdShopHidden = true
            if (e > 0) {
                this.zdShopHidden = false
            } else {
                this.form.distributor_id = []
            }
        },
        getData() {
            getOrderCardRow(this.$route.query.id)
                .then((response) => {
                    this.form = response.data.data;
                    if(this.form.use_type == 'package'){
                        this.getPackageList();
                    }
                    if (this.form.items_canuse > 0) {
                        this.zdItemHidden = false
                    }
                    if (this.form.distributor_canuse > 0) {
                        this.zdShopHidden = false;
                    }
                    this.$nextTick(() => {
                        this.distributor_list = this.form.distributor_list;
                        this.relItems = this.form.item_list;
                    })
                })
        },
        onSubmit() {
            if (this.$route.query && this.$route.query.id != undefined) {
                this.edit();
            } else {
                this.save();
            }
        },
        save() {
          if (this.form.use_type === 'offlinecard') {
            let data = this.form.cardinfo;
            let ids = [];
            data.forEach(element => {
                ids.push(element.id)
            });
            this.form.send_card_ids = ids;
          }
          console.log(this.form)
          const that = this
          saveOrderCard(this.form).then((response) => {
            this.$message({
              type: "success",
              message: response.data.data.msg,
              duration: 2000,
              onClose() {
                that.refresh()
                that.$router.go(-1)
              }
            });
          })
        },
        edit() {
            const that = this
            editOrderCard(this.$route.query.id, this.form)
                .then((response) => {
                    this.$message({
                        type: "success",
                        message: response.data.data.msg,
                        duration: 2000,
                        onClose() {
                            that.refresh()
                            that.$router.go(-1)
                        }
                    });
                })
        },
    },
    mounted() {
        if (this.$route.query && this.$route.query.id != undefined) {
            this.getData(this.$route.query.id);
        }
    },
};
</script>
<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// edit.vue?ac0264b6